import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "product-family__finishes" }
const _hoisted_2 = { class: "product-family__finishes-col-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "product-family__finish-label" }, "Selected Finish:", -1 /* HOISTED */)
const _hoisted_4 = { class: "product-family__finish-name" }
const _hoisted_5 = { class: "product-family__finishes-col-2" }
const _hoisted_6 = {
  class: "product-family__slider-wrap",
  ref: "pfSwiperParent"
}
const _hoisted_7 = {
  class: "product-family__slider swiper js-product-family-slider",
  ref: "pfSwiperInstance"
}
const _hoisted_8 = { class: "swiper-wrapper" }
const _hoisted_9 = ["onClick", "title"]
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  class: "swiper-button-next product-family__arrow-right",
  ref: "rightArrow"
}
const _hoisted_12 = {
  class: "swiper-button-prev product-family__arrow-left",
  ref: "leftArrow"
}
const _hoisted_13 = { class: "product-family__portfolio" }
const _hoisted_14 = { class: "section-large" }
const _hoisted_15 = { class: "d-flex justify-content-center align-items-stretch flex-column flex-md-row" }
const _hoisted_16 = { class: "mx-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "portfolioSelection",
  class: "d-block form-check-label"
}, "Filter By Portfolio", -1 /* HOISTED */)
const _hoisted_18 = { class: "d-block" }
const _hoisted_19 = { class: "d-block" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Portfolio Type", -1 /* HOISTED */)
const _hoisted_21 = ["value", "selected"]
const _hoisted_22 = {
  key: 0,
  class: "d-block py-1"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("strong", { class: "text-red" }, "X", -1 /* HOISTED */)
const _hoisted_25 = { class: "mx-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "portfolioSelection",
  class: "d-block form-check-label mt-4 mt-md-0"
}, "Filter By Style", -1 /* HOISTED */)
const _hoisted_27 = { class: "d-block" }
const _hoisted_28 = { class: "d-block" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Style", -1 /* HOISTED */)
const _hoisted_30 = ["value", "selected"]
const _hoisted_31 = {
  key: 0,
  class: "d-block py-1"
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("strong", { class: "text-red" }, "X", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, _toDisplayString($props.activeFinish.displayName || $props.activeFinish.title), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.finishes, (finish) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: finish?.title,
                  class: "swiper-slide product-family__finishes-item"
                }, [
                  _createElementVNode("a", {
                    href: null,
                    onClick: (e) => _ctx.$emit('filterChange', finish, $data.portfolio, $data.style, e),
                    class: _normalizeClass(['product-family__finishes-link', 'js-tooltip', $options.isActiveFinish(finish) && 'product-family__finishes-link--active']),
                    title: finish.displayName || finish?.title
                  }, [
                    _createElementVNode("img", {
                      src: $options.finishThumb(finish.thumbnail),
                      class: "product-family__finishes-img"
                    }, null, 8 /* PROPS */, _hoisted_10)
                  ], 10 /* CLASS, PROPS */, _hoisted_9)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ], 512 /* NEED_PATCH */),
          _createElementVNode("div", _hoisted_11, null, 512 /* NEED_PATCH */),
          _createElementVNode("div", _hoisted_12, null, 512 /* NEED_PATCH */)
        ], 512 /* NEED_PATCH */)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("select", {
                  name: "portfolioSelection",
                  id: "portfolioSelection",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.portfolio) = $event)),
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.changedFilter && $options.changedFilter(...args))),
                  class: "form-control"
                }, [
                  _hoisted_20,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.portfolios, (port) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: port?.title,
                      selected: $data.portfolio === port?.title
                    }, _toDisplayString(port?.title), 9 /* TEXT, PROPS */, _hoisted_21))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                  [_vModelSelect, $data.portfolio]
                ])
              ]),
              ($data.portfolio)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("a", {
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.resetPortfolioFilter && $options.resetPortfolioFilter(...args))),
                      href: "#"
                    }, [
                      ($data.portfolio)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                            _hoisted_24,
                            _createTextVNode(" Unset " + _toDisplayString($data.portfolio) + " Portfolio Filter", 1 /* TEXT */)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _withDirectives(_createElementVNode("select", {
                  name: "styleSelection",
                  id: "styleSelection",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.style) = $event)),
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($options.changedFilter && $options.changedFilter(...args))),
                  class: "form-control"
                }, [
                  _hoisted_29,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.styles, (styleOption) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: styleOption?.title,
                      selected: $data.style === styleOption?.title
                    }, _toDisplayString(styleOption?.title), 9 /* TEXT, PROPS */, _hoisted_30))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                  [_vModelSelect, $data.style]
                ])
              ]),
              ($data.style)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("a", {
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($options.resetStyleFilter && $options.resetStyleFilter(...args))),
                      href: "#"
                    }, [
                      ($data.style)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                            _hoisted_33,
                            _createTextVNode(" Unset " + _toDisplayString($data.style) + " Filter", 1 /* TEXT */)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}